/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_Empty_LaterInputs */

const en_landing_calendar_empty_later = /** @type {(inputs: Landing_Calendar_Empty_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open times show up here as soon as the trainer opens them.`)
};

const pl_landing_calendar_empty_later = /** @type {(inputs: Landing_Calendar_Empty_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wolne terminy pojawią się tutaj, gdy tylko trener je otworzy.`)
};

/**
* | output |
* | --- |
* | "Open times show up here as soon as the trainer opens them." |
*
* @param {Landing_Calendar_Empty_LaterInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_empty_later = /** @type {((inputs?: Landing_Calendar_Empty_LaterInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_Empty_LaterInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_empty_later(inputs)
	return en_landing_calendar_empty_later(inputs)
});